export function getBackendBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    // فرانت روی ساب‌دامین استاتیک است؛ API روی دامنه اصلی Laravel
    if (
      host === 'finance.darvagco.ir' ||
      host === 'project-manager.darvagco.ir'
    ) {
      return 'https://darvagco.ir';
    }
  }
  const url = import.meta.env.VITE_BACKEND_URL;
  return url ? String(url).replace(/\/$/, '') : '';
}

/** مسیر صفحه لاگین با رعایت base (مثلاً /panel/accounting/login) */
export function getLoginPath(): string {
  const base = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
  return base ? `${base}/login` : '/login';
}
